import '@mdi/font/css/materialdesignicons.css'
// import 'vuetify/styles'
// import { createVuetify } from 'vuetify'
// import { VOverlay, VCard, VCheckbox, VIcon } from 'vuetify/components'
// import { aliases, mdi } from 'vuetify/iconsets/mdi'
// import NutUI from '@nutui/nutui'
import '@nutui/nutui/dist/style.css'
import type { App } from 'vue'
import Echarts from '@/components/echarts.vue'
import Watermark from '@/components/watermark.vue'
import WatermarkCanvas from '@/components/watermark-canvas.vue'

export default {
  install(app: App) {
    // const vuetify = createVuetify({
    //   components: {
    //     VOverlay,
    //     VCard,
    //     VCheckbox,
    //     VIcon,
    //   },
    //   icons: {
    //     defaultSet: 'mdi',
    //     aliases,
    //     sets: { mdi },
    //   },
    // })
    // app.use(vuetify).use(NutUI)
    // app.use(vuetify)
    app.component('Echarts', Echarts)
    app.component('Watermark', Watermark)
    app.component('WatermarkCanvas', WatermarkCanvas)
  },
}
